import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './SubmittalModal.css';
import FormModal from 'components/shared/modal/FormModal';
import RouteTitle from 'components/shared/route-title/RouteTitle';
import SubmittalForm from 'components/admin/projects/details/project-submittal-log/SubmittalForm';
import SubmittalCard from 'components/admin/projects/details/project-submittal-log/SubmittalCard';
import SubmittalStamp from 'components/admin/projects/details/project-submittal-log/SubmittalStamp';
import SubmittalComments from 'components/admin/projects/details/project-submittal-log/SubmittalComments';
import SubmittalLeadTimeForm from 'components/admin/projects/details/project-submittal-log/SubmittalLeadTimeForm';
import SubmittalActions from 'components/admin/projects/details/project-submittal-log/SubmittalActions';
import { Row, Col } from 'react-bootstrap';

class SubmittalModal extends Component {
  static propTypes = {
    currentUser: PropTypes.shape({}).isRequired,
    project: PropTypes.shape({}).isRequired,
    submittal: PropTypes.shape({}),
    show: PropTypes.bool.isRequired,
    showLeadTime: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
  };

  render() {
    const {
      currentUser,
      project,
      submittal,
      show,
      showLeadTime,
      handleClose,
    } = this.props;
    return (
      <FormModal
        className="submittal-modal"
        show={show}
        onClose={handleClose}
        subTitle={
          <RouteTitle
            titles={[
              'Projects',
              project.name,
              submittal
                ? `Submittal ${submittal.csi_code.division}-${submittal.number}`
                : 'Add Submittal',
            ]}
          />
        }
      >
        <div className="submittal-body">
          <SubmittalForm currentUser={currentUser} project={project} />

          <hr />

          <Row>
            <Col sm={submittal ? 7 : 12}>
              <SubmittalCard
                currentUser={currentUser}
                project={project}
                submittal={submittal}
              />

              <SubmittalStamp currentUser={currentUser} submittal={submittal} />

              {showLeadTime && <SubmittalLeadTimeForm />}
            </Col>
            {submittal && (
              <Col sm={5}>
                <SubmittalComments submittal={submittal} />
              </Col>
            )}
          </Row>

          <hr />

          <SubmittalActions
            currentUser={currentUser}
            project={project}
            submittal={submittal}
            showLeadTime={showLeadTime}
            handleClose={handleClose}
          />
        </div>
      </FormModal>
    );
  }
}

export default connect()(SubmittalModal);



// WEBPACK FOOTER //
// ./src/components/admin/projects/details/project-submittal-log/SubmittalModal.js